import React, { Fragment, useEffect, useState } from "react";

// Analytics
import mixpanel from 'mixpanel-browser';

// Components
import Header from "../components/Header";
import Proof from "../components/Proof";
import Features from "../components/Features";
import HowTo from "../components/HowTo";
import Pricing from "../components/Pricing";
import FAQ from "../components/FAQ";
import Footer from "../components/Footer";
import Controls from "../components/Controls";

// Icons
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

const Landing = () => {

  // Analytics 
  const [sentMixpanel, setSentMixpanel] = useState(false);

  const [scrollToTop, setShowToTop] = useState(false);

  // scroll to section on page load if '#' is detected in URL
  useEffect(() => {
    const hash = window.location.hash; // Get hash from URL
    if (hash) {
        const element = document.getElementById(hash.substring(1)); // Remove "#" from hash
        if (element) {
            element.scrollIntoView({ behavior: "smooth" });
        }
    }
  }, []); 

  // Conditionally render scroll to top btn
  useEffect(() => {

    window.addEventListener('scroll', () => {
      const scrollPosition = window.scrollY;

      if(scrollPosition > 1000) {
        setShowToTop(true);
      } else {
        setShowToTop(false);
      }
    });
  }, []); 

  // Function to handle Mixpanel analytics
  const handleMixpanel = () => {
    mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN);
    mixpanel.track("Landing Page View");
  }

  // Trigger Mixpanel analytics on initial render in production mode
  if(process.env.NODE_ENV === 'production' && !sentMixpanel) {
      handleMixpanel();
      setSentMixpanel(true);
  }

  return (
    <div style={{background: 'hsla(0,0%,100%,.05)', position: 'relative'}}>
      <Header />
      <Proof />
      <Features />
      <HowTo />
      <Controls />
      <Pricing />
      <FAQ />
      <Footer />

      {/* Conditionally render scroll to top btn */}
      {scrollToTop && (
        <div style={{zIndex: 899, fontSize: '1.25rem', color: '#000', position: 'fixed', background: 'rgb(255,255,255,.5)', height: '60px', width: '60px', borderRadius: '50%', right: 15, bottom: 15, display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer'}} onClick={() => {
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        }}>
          <ArrowUpwardIcon />
        </div>
      )}
    </div>
  );
};

export default Landing;
